(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/views/spelguide/spelguide.js') >= 0) return;  svs.modules.push('/modules/maltipset/views/spelguide/spelguide.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.maltipset=_svs.maltipset||{};
_svs.maltipset.templates=_svs.maltipset.templates||{};
svs.maltipset.templates.spelguide = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"spelguide-tabview\">\n\n</div>";
},"useData":true});
Handlebars.partials['svs-maltipset-spelguide'] = svs.maltipset.templates.spelguide;
})(svs, Handlebars);

 })(window);